var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "head-container" },
      [
        _c("el-input", {
          staticClass: "filter-item",
          attrs: {
            clearable: "",
            size: "small",
            placeholder: "输入名称搜索",
            "prefix-icon": "el-icon-search"
          },
          model: {
            value: _vm.filterText,
            callback: function($$v) {
              _vm.filterText = $$v
            },
            expression: "filterText"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      {
        staticStyle: { overflow: "auto", "overflow-x": "hidden" },
        style: { height: _vm.treeheight - 50 + "px" }
      },
      [
        _c("el-tree", {
          ref: "tree",
          attrs: {
            data: _vm.treeData,
            "node-key": "id",
            props: _vm.defaultProps,
            accordion: "",
            "highlight-current": "",
            "filter-node-method": _vm.filterNode
          },
          on: { "node-click": _vm.handleNodeClick }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }